/* TODO: Unfortunately, this will be loaded every time the app loads. It's placed
 *        here alongside a controller in the hopes that someday we'll have the ability
 *        to progressively load JS controller code based on when data-controller="controller"
 *        is invoked, same as the connecting controller. */
import "@lottiefiles/lottie-player"
import {Controller} from "stimulus"

export default class extends Controller {}
